import sortByPriority from './sortByPriority';

export const getInsiderTransactionTickers = (
  (topic) => topic?.tickers
    ?.filter((ticker) => ticker.full_name?.endsWith('_US'))
    .sort(sortByPriority) ?? []
);

export default getInsiderTransactionTickers;
